import {useEffect} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {CssBaseline, ThemeProvider} from '@mui/material'

import theme from './themes/mui'
import Navbar from './components/organisms/Navbar/Navbar'
import BottomNav from './components/organisms/BottomNav/BottomNav'
import {Route} from './router'

import './App.css'
import ConnectionProvider from './components/hooks/ConnectionProvider'
import AuthProvider from './components/hooks/AuthProvider'

interface AppProps {
    noNavbar?: boolean
    noBottomNav?: boolean
}

function App({noNavbar = false, noBottomNav = false}: AppProps) {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.pathname === '/') {
            navigate(Route.HOME, {replace: true})
        }
    }, [])

    return (
        <div className="App">
            <ConnectionProvider>
                <AuthProvider>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <div className="AppContainer">
                            {!noNavbar && <Navbar />}
                            <Outlet />
                            {!noBottomNav && <BottomNav />}
                        </div>
                    </ThemeProvider>
                </AuthProvider>
            </ConnectionProvider>
        </div>
    )
}

export default App
